/*
*   Create a component custom to save product grid layout in mobile
*/

class GridToggle extends HTMLElement {
    connectedCallback() {
        this.init();
    }

    init() {
        const inputs = this.querySelectorAll('input[name="plp-grid-btn"]');

        // Recupera il valore dal cookie
        const savedValue = CookieUtils.getCookie('plp-grid-btn');

        if (savedValue) {
            const savedInput = this.querySelector(`#${savedValue}`);
            if (savedInput) savedInput.checked = true;
        }

        // Assegna gli event listener per salvare nei cookie
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                CookieUtils.setCookie('plp-grid-btn', input.id, 7); // Salva per 7 giorni
            });
        });
    }
}

customElements.define('grid-toggle', GridToggle);